/*
 * Settings state
 *
 * Change game settings
 */


export default class Settings extends Phaser.State {
  init () {
    // TODO: Stub
  }

  preload () {
    // TODO: Stub
  }

  create () {
    // TODO: Stub
  }

  update () {
    // TODO: Stub
  }

  render () {
    // TODO: Stub
  }
}
